var _ellipse, _ellipse2, _circle, _circle2, _path, _path2, _circle3, _circle4, _path3, _path4, _path5, _line, _line2, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChickenSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chickenFooterGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1DD3B0",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FFB800",
      stopOpacity: 0.4
    }
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 28,
    rx: 11,
    ry: 12,
    fill: "url(#chickenFooterGradient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 28,
    rx: 11,
    ry: 12,
    stroke: "#1DD3B0",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 15,
    r: 6,
    fill: "url(#chickenFooterGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 15,
    r: 6,
    stroke: "#1DD3B0",
    strokeWidth: 1.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21 11 Q 22.5 7 24 10 Q 25.5 7 27 11",
    stroke: "#FFB800",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 24 19 Q 21 21 22 24",
    stroke: "#FFB800",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 15,
    r: 1.5,
    fill: "#1DD3B0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3,
    cy: 14.7,
    r: 0.6,
    fill: "#E8EAED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 29 15 L 33 14 L 29 16 Z",
    fill: "#FFB800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 33 26 Q 36 28 35 31",
    stroke: "#1DD3B0",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 33 29 Q 35 30 33 32",
    stroke: "#1DD3B0",
    strokeWidth: 1.2,
    fill: "none",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 38,
    x2: 20,
    y2: 43,
    stroke: "#FFB800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 38,
    x2: 28,
    y2: 43,
    stroke: "#FFB800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 17 43 L 20 43 L 23 43",
    stroke: "#FFB800",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 25 43 L 28 43 L 31 43",
    stroke: "#FFB800",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 14 25 Q 10 24 11 21",
    stroke: "#1DD3B0",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 14 28 Q 8 28 9 25",
    stroke: "#1DD3B0",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 14 31 Q 10 32 11 34",
    stroke: "#1DD3B0",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenSmall);
export default __webpack_public_path__ + "static/media/chicken-small.1245589335f1ff4447bab6ca326d9372.svg";
export { ForwardRef as ReactComponent };